import React from "react";
import OptixDataFormatted from "./OptixDataFormatted";

const FormatData = ({
  result_data,
  question_list_data,
  auditID,
  category,
  store_type,
  sos_result,
  time,
  sod_result,
  count
}) => {
  function formatJson(data) {
    if (data !== "") {
      const items = data.split(",");

      const dataArray = [];

      items.forEach((item) => {
        const [question, answer] = item.split(":");
        dataArray.push({ question: question.trim(), answer: answer.trim() });
      });

      const jsonData = { dataArray };
      return dataArray;
    }
    else{
      return "";
    }
  }
  const dataArray1 = formatJson(result_data);
  const dataArray2 = formatJson(sos_result);
  const dataArray3 = formatJson(sod_result);

  //dispatch(getResultDataSuccess(jsonData));
  //console.log(jsonData);

  const items1 = question_list_data.split(";"); // Split data into individual items

  const dataArray4 = [];

  items1.forEach((item) => {
    const parts = item.split(":");
    if (parts.length === 2) {
      const [question, answer] = parts;
      dataArray4.push({ question: question.trim(), answer: answer.trim() });
    } else {
      // Skip invalid data or items without a colon
      // console.warn(`Skipping invalid item: ${item}`);
    }
  });

  //const jsonData1 = { dataArray4 };
  const mapData = [
    { data: dataArray1, type: "dgp" },
    {
      data: dataArray4,
      type: "vgp",
    },
    {
      data: dataArray2,
      type: "sos",
    },
    {
      data: dataArray3,
      type: "sod",
    },
  ];
  console.log(mapData);
  return (
    <>
      {mapData.map((m) => (
         m.data && m.data.length > 0 ? (
          <OptixDataFormatted
            key={m.type}
            data={m.data}
            auditID={auditID}
            category={category}
            store_type={store_type}
            type={m.type}
            time={time}
            count={count}
          />
        ) : null
      ))}
      {/* <FormatData2 data={dataArray} auditID={auditID} category={category} store_type={store_type} type="dgp"/>
      <FormatData2 data={dataArray1}  auditID={auditID} category={category} store_type={store_type} type="vgp"/> */}
    </>
  );
};

export default FormatData;
